// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DarkTheme__sidebar___35zPP {
    border-right-color: var(--steel3);
  }
  .DarkTheme__list-heading___20CGg, .DarkTheme__anchor___3FH2Z, .DarkTheme__menu-back___8GLL8 {
    color: var(--aluminum4);
  }
`, "",{"version":3,"sources":["webpack://./../node_modules/@mulesoft/anypoint-components/raw/platform-components/Sidebar/themes/DarkTheme.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;EACnC;EACA;IACE,uBAAuB;EACzB","sourcesContent":[".DarkTheme__sidebar___35zPP {\n    border-right-color: var(--steel3);\n  }\n  .DarkTheme__list-heading___20CGg, .DarkTheme__anchor___3FH2Z, .DarkTheme__menu-back___8GLL8 {\n    color: var(--aluminum4);\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
